import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Session } from "../../services/sessionsService";

interface SessionsState {
  patientSessions: {
    [patientUid: string]: Session[];
  };
  loading: boolean;
  error: string | null;
}

const initialState: SessionsState = {
  patientSessions: {},
  loading: false,
  error: null,
};

const sessionsSlice = createSlice({
  name: "sessions",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPatientSessions: (
      state,
      action: PayloadAction<{ patientUid: string; sessions: Session[] }>
    ) => {
      state.patientSessions[action.payload.patientUid] =
        action.payload.sessions;
      state.loading = false;
      state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearPatientSessions: (state, action: PayloadAction<string>) => {
      delete state.patientSessions[action.payload];
    },
    clearAllSessions: (state) => {
      state.patientSessions = {};
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setLoading: setSessionsLoading,
  setPatientSessions,
  setError: setSessionsError,
  clearPatientSessions,
  clearAllSessions,
} = sessionsSlice.actions;

export { sessionsSlice };
export default sessionsSlice.reducer;
